<template>
    <div>
        <h4 class="ticket-group-title" :class="{'ticket-group-title-bulk': mode === 'bulk'}" v-if="group.title">{{ group.title }}</h4>

        <!--Ticket View-->
        <template v-if="view==='tickets'">
            <ticket v-for="registrationCategory in registrationCategories"
                    :registration-category="registrationCategory"></ticket>
        </template>

        <!--Table-->
        <div v-else>
            <!-- Standard mode - with card -->
            <div v-if="mode === 'standard'" class="card mb-4">
                <div class="card-body px-0 py-0">
                    <table-container
                        :registration-categories="registrationCategories"
                    ></table-container>
                </div>
            </div>

            <!-- Bulk mode - no card -->
            <bulk-table-container
                v-else
                :registration-categories="registrationCategories"
                :value="value"
                @input="$emit('input', $event)"
                :disabled="disabled"
                :top-up-bulk-action="topUpBulkAction"
            ></bulk-table-container>
        </div>
    </div>
</template>

<script>
import Ticket from "./Ticket/Ticket";
import TableContainer from "./Table/TableContainer";
import BulkTableContainer from "./Table/BulkTableContainer";

export default {
    name: "Group",
    components: {
        TableContainer,
        BulkTableContainer,
        Ticket,
    },
    props: {
        group: {
            type: Object,
            default: () => {
                {
                }
            },
            required: true,
        },
        view: {
            type: String,
            default: 'tickets',
            required: false
        },
        mode: {
            type: String,
            default: 'standard'
        },
        value: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        },
        topUpBulkAction: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        registrationCategories() {
            // Sort by priority
            return this.group.registration_categories.sort(function(a, b){
                return a.priority - b.priority
            })
        }
    },
}
</script>

<style scoped>
/* Group Header Styling - Default (Standard Mode) */
.ticket-group-title {
    /* Default styling - keep original look */
}

/* Group Header Styling - Bulk Mode */
.ticket-group-title-bulk {
    color: #2c3e50;
    font-weight: 700;
    font-size: 1.1rem;
    padding: 0.5rem 0;
    margin-bottom: 0.7rem;
    margin-top: 2rem !important;
}

.ticket-group-title-bulk:first-child {
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Group.vue